import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, refetchOnWindowFocus: false } },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register service worker for offline / installable PWA.
// Whenever the app boots we force `update()` on the existing registration so
// old service workers (e.g. the poisoned `operant-v1` cache from before 2026-08-14)
// pick up `sw.js` v2 immediately instead of waiting for Safari's periodic check.
// If we detect that ancient cache we also nuke it directly.
if ("serviceWorker" in navigator && window.location.protocol === "https:") {
  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js");
      reg.update().catch(() => {});
    } catch { /* ignore */ }
    // One-shot cleanup: purge the legacy `operant-v1` cache if it's still hanging around.
    if ("caches" in window) {
      try {
        const keys = await caches.keys();
        await Promise.all(keys.filter((k) => k === "operant-v1").map((k) => caches.delete(k)));
      } catch { /* ignore */ }
    }
  });
}
